import React from 'react';
import { useSelector } from 'react-redux';
import { canMakeSales } from '../../utils/roles';
import PropTypes from 'prop-types';
import { NavLink, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSidebarData from '../../core/json/siderbar_data';

export default function Sidebar({ collapsed = false, onNavigate }) {
  const sections = useSidebarData();
  const role = useSelector(state => state.rootReducer.user_infos?.role);
  const home = canMakeSales(role) ? '/pos-2' : role === 'logistic' ? '/manage-stocks' : '/customers';
  const { t } = useTranslation();
  return <nav className={`ui-navigation ${collapsed ? 'is-collapsed' : ''}`} aria-label={t('ui.navigation')}>
    <Link to={home} className="ui-brand" onClick={onNavigate} aria-label="SpecificsPOS">
      <img src={collapsed ? '/assets/img/logo-small.png' : '/assets/img/logo.png'} alt="SpecificsPOS" />
    </Link>
    <div className="ui-navigation-sections">
      {sections.map(section => <section key={section.id} className="ui-navigation-section" aria-label={section.label}>
        <h2>{section.label}</h2>
        {section.submenuItems.map(item => <NavLink key={item.link} to={item.link} onClick={onNavigate}
          title={collapsed ? item.label : undefined} aria-label={item.label}
          className={({ isActive }) => `ui-nav-link ${isActive ? 'is-active' : ''}`}>
          <i className={`ti ti-${item.icon}`} aria-hidden="true" /><span>{item.label}</span>
        </NavLink>)}
      </section>)}
    </div>
    <div className="ui-navigation-footer"><span>SpecificsPOS</span><span>{t('ui.workspace')}</span></div>
  </nav>;
}
Sidebar.propTypes = { collapsed: PropTypes.bool, onNavigate: PropTypes.func };
